module.exports = __webpack_public_path__ + "static/media/puff.ef13fc63.gif";